import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useFormik } from 'formik'
import qs from 'qs'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Message } from '@components/shared/Message'

export const ResetPassword = () => {
    
    const navigate = useNavigate()
    
    const [userId, setUserId] = useState()
    const [token, setToken] = useState('')
    const [message, setMessage] = useState()
    
    const userStage = useWireValue(store.userStage)
    
    const formik = useFormik({
        initialValues: { password: '', confirmPassword: '' },
        onSubmit: async values => {
            const passwordRegex = new RegExp('^(((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})')
            
            if (!values.password || !values.confirmPassword) {
                setMessage({
                    text: 'Please fill in all the fields.',
                    level: 'danger',
                })
            } else if (values.password !== values.confirmPassword) {
                setMessage({
                    text: 'Password and confirm password does not match.',
                    level: 'danger',
                })
            } else if (!passwordRegex.test(values.password)) {
                setMessage({
                    text: 'Password does not meet the requirements.',
                    level: 'danger',
                })
            } else {
                
                setMessage(undefined)
                
                try {
                    await actions.setUserPassword(userId, token, values.password)
                    navigate('/signin')
                } catch (e) {
                    setMessage({
                        text: 'Unexpected error. Please try again.',
                        level: 'danger',
                    })
                }
                
            }
        },
    })
    
    const location = useLocation()
    
    useEffect(() => {
        
        const id = qs.parse(location.search, { ignoreQueryPrefix: true }).id
        const token = qs.parse(location.search, { ignoreQueryPrefix: true }).token
        
        if (typeof id === 'string')
            setUserId(id)
        
        if (typeof token !== 'string') return
        
        setToken(token)
        
    }, [location])
    
    useEffect(() => {
        
        if (userId)
            actions.getUserStage(userId)
        
    }, [userId])
    
    useEffect(() => {
        
        if (userStage?.length && userStage !== 'forgotPassword')
            navigate('/signin')
        
    }, [userStage])
    
    const { handleSubmit, handleChange } = formik
    
    return (
        <div className="flex flex-col items-center justify-center" style={{ height: '99vh' }}>
            <div className="row justify-center items-center">
                <div className="w-full max-w-lg py-20 rounded-lg px-20 bg-base-300/10 bg-opacity-30 mx-auto sm:my-8">
                    <div
                        style={{
                            marginBottom: '25px',
                            width: '90%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: '0 auto 20px',
                        }}>
                        <img src="img/logo.png" width="100%" height="100%" alt="" />
                    </div>
                    <div className="text-center">
                        <h2>Please create your password</h2>
                        <section className="mt-6 login-form">
                            {message && <Message style={{ textAlign: 'left', margin: '0.75rem' }} message={message} />}
                            <form onSubmit={handleSubmit}>
                                <div className="mb-2 form-group">
                                    <input
                                        type="password"
                                        name="password"
                                        id="password"
                                        className="input input-bordered w-full"
                                        onChange={handleChange}
                                        placeholder="Password"/>
                                </div>
                                <div className="mb-2 form-group">
                                    <input
                                        type="password"
                                        name="confirmPassword"
                                        id="confirm-password"
                                        className="input input-bordered w-full"
                                        onChange={handleChange}
                                        placeholder="Confirm Password"/>
                                </div>
                                <div className="mb-2" style={{ fontSize: '14px' }}>
                                    <small>Use 8 or more characters with a mix of letters, numbers & symbols.</small>
                                </div>
                                <div className="mb-2 form-group">
                                    <input
                                        type="submit"
                                        value="Save"
                                        disabled={!token?.length}
                                        className="mb-3 btn w-full btn-lg btn-primary btn-outline"/>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}
